import { VIRTUAL_PAGEVIEWS as PAGES } from '@sm360/widget-commons-general';
import * as SECTIONS from 'build-and-quote/constants/sections.js';

export default {
    [SECTIONS.MODEL_YEARS.value]: PAGES.BUILD_AND_QUOTE_YEAR,
    [SECTIONS.MODEL_TRIMS.value]: PAGES.BUILD_AND_QUOTE_TRIM,
    [SECTIONS.DRIVE_POWER_TRAINS.value]: PAGES.BUILD_AND_QUOTE_PERFORMANCE,
    [SECTIONS.OPTIONS_PACKAGES.value]: PAGES.BUILD_AND_QUOTE_COMFORT,
    [SECTIONS.OPTIONS_AND_ACCESSORIES.value]: PAGES.BUILD_AND_QUOTE_ACCESSORIES,
    [SECTIONS.CONFIRMATION.value]: PAGES.VDP_NEW,
};
